import type {FC} from 'react';
import {memo, useContext, useMemo} from 'react';

import YcIcon from '@yourcoach/shared/assets/gamification/yc.svg';
import {ThemeContext} from '@yourcoach/shared/styles';

import styles from './styles.module.css';

const ICON_SIZE_ASPECT = 0.7;

interface Props {
  backgroundColor?: string;
  size?: number;
}

const YcCoin: FC<Props> = ({backgroundColor, size = 14}) => {
  const {theme} = useContext(ThemeContext);
  const iconSize = useMemo(() => size * ICON_SIZE_ASPECT, [size]);
  const backgroundColorMemo = useMemo(
    () => backgroundColor || theme.color.v3.background.primary,
    [backgroundColor, theme],
  );

  const style = useMemo(
    () => ({
      alignItems: 'center',
      backgroundColor: backgroundColorMemo,
      borderRadius: size / 2,
      display: 'flex',
      height: size,
      justifyContent: 'center',
      minHeight: size,
      minWidth: size,
      width: size,
    }),
    [backgroundColorMemo, size],
  );

  return (
    <div className={`YcCoin ${styles.YcCoin}`} style={style}>
      <YcIcon fill={theme.color.icon2} height={iconSize} width={iconSize} />
    </div>
  );
};

export default memo(YcCoin);
